import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../api/axiosInstance';
// Thunk to fetch About Us data
export const fetchAboutUs = createAsyncThunk(
  'aboutUs/fetchAboutUs',
  async ({language}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/api/Common/GetAboutUSHomePage', {
        headers: {
            "lang": language === "English" ? "2" : "1",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const aboutUsSlice = createSlice({
  name: 'aboutUs',
  initialState: {
    data: null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAboutUs.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchAboutUs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchAboutUs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default aboutUsSlice.reducer;
